import script from "./MeshTopology.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeshTopology.vue?vue&type=script&setup=true&lang=ts"

import "./MeshTopology.vue?vue&type=style&index=0&id=331a5432&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331a5432"]])

export default __exports__